import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../utils/withDefaults';
const LabelRoot = styled(Typography)(({
  theme
}) => ({
  padding: theme.spacing(1, 2)
}));
export const Label = withDefaults(LabelRoot, {
  variant: 'Lato Caption Bold'
});